module.exports = __webpack_public_path__ + "static/img/sadbear.d57503d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sadbear.svg
// module id = c1t6
// module chunks = 12